import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import IconLabel from '../util/IconLabel';
import styles from './CollectionButton.css';
import stylesShareButton from './ShareButton.css';
import CapacitorRipple from '../capacitor/Ripple';
import { commonMessages } from '../messages/Common';
class CollectionButton extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    hideText: PropTypes.bool,

    intl: intlShape,
  };

  static defaultProps = {
    disabled: false,
    hideText: true,
  };

  onClick = () => {
    if (this.props.disabled) {
      return;
    }

    this.props.onClick();
  };

  render() {
    const { className, active, hideText, intl, disabled } = this.props;

    const buttonClassNames = classnames(stylesShareButton.shareButton, className, {
      [stylesShareButton.isDisabled]: disabled,
      [styles.isActive]: active,
    });

    const text = !active
      ? intl.formatMessage(commonMessages.saveToCollection)
      : intl.formatMessage(commonMessages.removeFromCollection);

    const size = hideText ? 'default' : 'small';

    return (
      <button
        className={buttonClassNames}
        onClick={this.props.onClick}
        title={text}
        aria-label={hideText ? text : null}
        data-test="add-to-collection-button"
      >
        <CapacitorRipple version="center" />
        <div>
          <IconLabel
            name="heart"
            size={size}
            className={styles.iconDefault}
            labelVisible={!hideText}
            label={text}
          />
          <IconLabel
            name="heart-block"
            size={size}
            className={styles.iconActive}
            labelVisible={!hideText}
            label={text}
          />
        </div>
      </button>
    );
  }
}

export default injectIntl(CollectionButton);
